import { all, call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';

import api from '@api';
import { putError, putWarning } from '@utils/notificationUtils';
import { BookRoutePaths } from '@routes/routesPaths';

import { createBook, deleteBook, fetchBookList, updateBook } from './book.actions';
import { LoadersNames } from '../../ui/ui.actions';
import { uiActions } from '../../actions';
import { fetchAuthorList } from '../author/author.actions';

export function* bookListSaga() {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.book.bookListQuery);
    yield put(fetchBookList.done({ params: {}, result }));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_getting_book_list');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* createBookSaga({ payload }: ReturnType<typeof createBook.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.book.createBookMutation, payload);
    yield put(createBook.done({ params: payload, result }));
    yield put(fetchAuthorList.started({}));
    yield put(push(BookRoutePaths.bookRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_creating_book');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* updateBookSaga({ payload }: ReturnType<typeof updateBook.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.book.updateBookMutation, payload);
    yield put(updateBook.done({ params: payload, result }));
    yield put(push(BookRoutePaths.bookRoot));
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_updating_book');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* deleteBookSaga({ payload }: ReturnType<typeof deleteBook.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  try {
    const result = yield call(api.book.deleteBookMutation, payload);
    yield put(deleteBook.done({ params: payload, result }));
    yield put(push(BookRoutePaths.bookRoot));
    yield putWarning('app:msg_title_deleted', 'app:msg_book_deleted');
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_deleting_book');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* watchBookSaga() {
  yield all([
    yield takeLatest(fetchBookList.started, bookListSaga),
    yield takeLatest(createBook.started, createBookSaga),
    yield takeLatest(updateBook.started, updateBookSaga),
    yield takeLatest(deleteBook.started, deleteBookSaga),
  ]);
}
